<template>
    <div>
        <h3>企业管理</h3>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="创建者手机号">
                <el-input placeholder="输入手机号" v-model="filter.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="企业名称">
                <el-input placeholder="输入企业名称" v-model="filter.enterprise"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="entId" label="企业id"></el-table-column>
            <el-table-column prop="enterprise" label="企业名称"></el-table-column>
            <el-table-column prop="enterpriseSize" label="规模">
                <template slot-scope="scope">{{map.ent.size[scope.row.enterpriseSize]}}</template>
            </el-table-column>
            <el-table-column prop="industry" label="行业">
                <template slot-scope="scope">{{getIndustry(scope.row.industry)['name']}}</template>
            </el-table-column>
            <el-table-column prop="memberNum" label="成员数"></el-table-column>
            <el-table-column prop="phoneNumber" label="拥有者手机号"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-dropdown size="medium">
                        <span class="el-dropdown-link">
                            <i class="el-icon-menu" style="font-size: 24px;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <a :href="`/jobs?publisherId=${scope.row.userId}`" target="_blank">查看职位</a>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <a :href="`/orders?publisherId=${scope.row.userId}`" target="_blank">查看订单</a>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <a :href="`/member?publisherId=${scope.row.userId}`" target="_blank">查看成员</a>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'

import api from '../api'
let {
    ent,
    common
} = api
export default {
    name: 'entList',
    data() {
        return {
            map,
            filter: {
                phoneNumber: '',
                enterprise: '',
            },
            loading: true,
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            industries: [],
        }
    },
    computed: {
        uid() {
            return this.$route.query.uid;
        }
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    created() {
        this.getIndustries();
    },
    methods: {
        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1;
            }

            let {
                phoneNumber,
                enterprise,
            } = this.filter;
            this.loading = true;
            let {
                data: {
                    data,
                    code,
                    desc,
                    pageinfo,
                }
            } = await ent.list({
                pageNum: this.pageNum,
                limit: this.limit,
                phoneNumber,
                enterprise,
            })
            if (code == 200) {
                this.list = data;
                this.total = pageinfo.totalCount;
            }
            this.loading = false;
        },
        async getIndustries() {
            let {
                data: {
                    data,
                    code,
                }
            } = await common.getIndustries()
            if (code == 200) {
                this.industries = data;
            }
        },
        getIndustry(id) {
            let arr = this.industries,
                industry = {}

            for(let i=0;i<arr.length;i++) {
                if (arr[i].id === id) {
                    industry = arr[i];
                    break;
                }
            }
            return industry;
        },
    },
    mounted() {
        this.fetch()
    }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/ent/ents.vue